import {createContext, useCallback, useContext, useMemo, useState} from 'react';
import ProductService from '../services/ProductService';

const ProductDealsContext = createContext();

export const useProductDealsContext = () => useContext(ProductDealsContext);

export const ProductDealsContextProvider = ({ children }) => {
  const [productDeals, setProductDeals] = useState();

  const loadDeals = useCallback(async (productCode) => {
    setProductDeals(await ProductService.getProductDeals(productCode));
  }, []);

  const context = useMemo(() => ({
    productDeals,
    loadDeals
  }), [
    productDeals,
    loadDeals
  ]);

  return (
    <ProductDealsContext.Provider value={context}>
      {children}
    </ProductDealsContext.Provider>
  );
};